export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SocialAuthWelcomeDialog.json?hash=6c3e3b9372c22d1a83b03bf137745b85";